
import api from "./api";
import { format } from "date-fns";
const userRole = localStorage.getItem("role");
const isPM = userRole === "PM" || userRole === 'pm'
export const getStates = async () => {
  try {
    const response = await api.get('/api/states/nationality/1');
    return response.data;
  } catch (error) {

    throw new Error('Error fetching states');
  }
};

export const getAllDistrictBihar = async () => {
  const response = await api.get(`/api/districts/state/3`)
  return response.data

}
export const getAllDistrictBiharZD = async () => {
  const response = await api.get(`/api/districts/3/zones-districts`)
  return response.data

}
export const getDistrict = async (state) => {
  const response = await api.get(`/api/districts/state/${state}`)
  return response.data

}
export const getDistrictByZoneId = async (zoneId) => {
  const response = await api.get(`/api/zones/${zoneId}`)
  return response.data

}
export const getZonesAll = async () => {
  const response = await api.get(`/api/zones`)
  return response.data

}
export const getBlocks = async (district) => {
  const response = await api.get(`/api/blocks/district/${district}`)
  return response.data;
}

export const getClients = async (state) => {
  const response = await api.get(`/api/clients/by-state/${state}`)
  return response.data

}
export const getProject = async (clients) => {
  const response = await api.get(`/api/projects/client/${clients}`);
  return response.data
}

export const getProjects = async () => {
  const response = await api.get(`/api/projects`);
  return response.data
}
// http://localhost:8080/api/projects/client/1

// all months
export const fetchAllMonths = async (year) => {
  // Fetch months data from API
  const response = await api.get("/api/months");
  const data = response.data;

  // Get the current date details
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // months are 0-indexed, so add 1
  const currentDate = now.getDate();
  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

  // Map through the months data and calculate the number of days
  const months = data
    .map((item) => {
      let daysInMonth;

      // For other years, show full month days
      daysInMonth = new Date(year, item.monthId, 0).getDate();


      return {
        value: item.monthId,
        label: item.monthName,
        days: daysInMonth,
      };
    })
    .sort((a, b) => a.value - b.value); // Sort months in ascending order

  // Filter months based on the provided `year`
  let filteredMonths = months;

  return filteredMonths;
};

// previous month
export const fetchMonths = async (year) => {
  const response = await api.get("/api/months");
  const data = response.data;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const currentDate = now.getDate();
  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

  const months = data
    .map((item) => {
      let daysInMonth;
      if (year === currentYear && item.monthId === currentMonth) {
        daysInMonth = currentDate;
      } else {
        daysInMonth = new Date(year, item.monthId, 0).getDate();
      }
      return {
        value: item.monthId,
        label: item.monthName,
        days: daysInMonth,
      };
    })
    .sort((a, b) => a.value - b.value);

  let filteredMonths = months;
  if (year) {
    if (year === currentYear) {
      filteredMonths = months.filter((m) => {
        if (m.value < currentMonth) return true;
        if (m.value === currentMonth) {
          return currentDate === lastDayOfCurrentMonth;
        }
        return false;
      });
    } else if (year > currentYear) {
      filteredMonths = [];
    } else {
      filteredMonths = months;
    }
  }

  return filteredMonths;
};

// current month also
export const fetchMonthsCurrent = async (year) => {
  const response = await api.get("/api/months");
  const data = response.data;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 2;
  const currentDate = now.getDate();
  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

  const months = data
    .map((item) => {
      let daysInMonth;
      if (year === currentYear && item.monthId === currentMonth) {
        daysInMonth = currentDate;
      } else {
        daysInMonth = new Date(year, item.monthId, 0).getDate();
      }
      return {
        value: item.monthId,
        label: item.monthName,
        days: daysInMonth,
      };
    })
    .sort((a, b) => a.value - b.value);

  let filteredMonths = months;
  if (year) {
    if (year === currentYear) {
      filteredMonths = months.filter((m) => {
        if (m.value < currentMonth) return true;
        if (m.value === currentMonth) {
          return currentDate === lastDayOfCurrentMonth;
        }
        return false;
      });
    } else if (year > currentYear) {
      filteredMonths = [];
    } else {
      filteredMonths = months;
    }
  }

  return filteredMonths;
};


export const fetchEmployeePostingByLocation = async (payload) => {
  const response = await api.post("/api/employee-posting/by-location", payload);
  return response.data;
};

export const getMonthlyAttendanceReport = async (filters) => {
  const response = await api.get("/api/attendance/monthly", {
    params: filters,
  });
  return response.data;
};

export const getPendingAttendance = async (filters) => {
  const response = await api.get("/api/attendance/pending", {
    params: filters,
  });
  return response.data;
};
export const verifyAttendanceBulk = async (payload) => {
  const response = await api.post("/api/attendance/verify/bulk", payload);
  return response.data;
};

export const submitAttendance = (payload, hasResubmit) => {
  if (hasResubmit) {
    return api.patch("/api/attendance", payload); // update
  }
  return api.patch("/api/attendance", payload); // create
};

export const getFinalAttendanceReport = async (filters) => {
  const response = await api.get("/api/attendance/monthly/district-report", {
    params: filters,
  });
  return response.data;
};
export const getFinalAttendanceReportProjectWise = async (filters) => {
  const response = await api.get("/api/attendance/district-project-report", {
    params: filters,
  });
  return response.data;
};

export const getAnnexureEntry = async (filters) => {
  const response = await api.get("/api/attendance/monthly/designation-summary", {
    params: filters,
  });
  return response.data;
};

export const getAnnexureReport = async (filters) => {
  const response = await api.get("/api/annexure-a/fetch", {
    params: filters,
  });
  return response.data;
};
// export const getEmployeeForAttendance=async(state,district,clients,project)=>{
//    const response = await api.get(`/api/employee-posting/employees?stateId=${state}&districtId=${district}&clientId=${clients}&projectId=${project}`)
//    return response;
// }
export const getEmployeeForAttendance = async (state, district, clients, project) => {
  let url = `/api/employee-posting/employees?stateId=${state}&districtId=${district}&clientId=${clients}`
  if (project) {
    url += `&projectId=${project}`;
  }

  const response = await api.get(url)
  return response;
}

export const getLeavesEmployees = async (stateId, clients, districtId) => {
  try {

    let url = `/api/employee-posting/basic?stateId=${stateId}&clientId=${clients}`;
    if (districtId) {
      url += `&districtId=${districtId}`;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};
export const getLeavesEmployeesShowCause = async (stateId, districtId) => {
  try {

    let url = `/api/employee-posting/basic?stateId=${stateId}&districtId=${districtId}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};
export const selfAttendance = async (formData) => {
  try {
    const response = await api.post(
      "api/attendance/capture",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response;
  } catch (err) {
    throw err;
  }
};


export const selfieAttendanceReason = async () => {
  try {
    const response = await api.get("/api/attendance-reasons");
    return response.data;
  } catch (err) {
    throw err;
  }
}




export const getEmployeSatateAndDistrictWise = async (stateId, districtId) => {
  try {
    const response = await api.get(`/api/attendance/employees/by-state-district?stateId=${stateId}&districtId=${districtId}`)
    return response.data;
  }
  catch (error) {
    console.log("error", error)
  }

}


export const gettingAttendaceEmployeeWise = async (stateId, districtId, employee, fromDate, toDate) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');

    const response = await api.get(`/api/attendance/employee-attendance?stateId=${stateId}&districtId=${districtId}&employeeUniqueId=${employee}&fromDate=${formattedFromDate}&toDate=${formattedTodate}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}


export const getMonthlyLoginTimeReport = async (stateId, districtId, year, month) => {
  const response = await api.get(`/api/attendance/monthlylogintime-report`, {
    params: {
      stateId: stateId,
      districtId: districtId,
      year: year,
      month: month
    }
  });
  return response.data;
};


export const fetchMonthsByYears = async (year) => {
  const response = await api.get("/api/months");

  return response.data
    .map((item) => ({
      value: item.monthId,
      label: item.monthName,
      days: new Date(year, item.monthId, 0).getDate(),
    }))
    .sort((a, b) => a.value - b.value);
};


export const gettingAttendaceEmployeeWiseNotInTheLocation = async (stateId, districtId, fromDate, toDate, zoneId) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  // http://localhost:8080/api/attendance/attendance-distance-alerts?stateId=3&districtId=9&fromDate=2026-08-01&toDate=2026-08-17
  // http://localhost:8080/api/attendance/attendance-distance-alerts?stateId=3&fromDate=2026-08-01&toDate=2026-08-17&zoneId=1

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');
    let url = `/api/attendance/attendance-distance-alerts?stateId=${stateId}&fromDate=${formattedFromDate}&toDate=${formattedTodate}`;
    if (districtId) {
      url += `&districtId=${districtId}`;
    }
    const hasValidZoneId = zoneId && zoneId !== 'null' && zoneId !== 'undefined' && zoneId !== '';
    if (hasValidZoneId && !isPM) {
      url += `&zoneId=${zoneId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}


//http://localhost:8080/api/attendance/attendance-district-violations-summary?stateId=3&fromDate=2026-08-01&toDate=2026-08-01&zoneId=1
export const gettingAttendanceDistrictViolationsSummary = async (stateId, fromDate, toDate, zoneId) => {
  try {

    const formattedFromDate = format(new Date(fromDate), "yyyy-MM-dd");
    const formattedToDate = format(new Date(toDate), "yyyy-MM-dd");

    let url =
      `/api/attendance/attendance-district-violations-summary` +
      `?stateId=${stateId}` +
      `&fromDate=${formattedFromDate}` +
      `&toDate=${formattedToDate}`;

    // Only send districtId when it has a value
    // if (districtId !== null && districtId !== undefined && districtId !== "") {
    //   url += `&districtId=${districtId}`;
    // }
    const hasValidZoneId = zoneId && zoneId !== 'null' && zoneId !== 'undefined' && zoneId !== '';
    if (hasValidZoneId && !isPM) {
      url += `&zoneId=${zoneId}`;
    }
    const response = await api.get(url);


    return response.data;
  } catch (error) {
    console.error(
      "Error fetching district violations summary:",
      error
    );
    throw error;
  }
};


export const gettingAttendaceEmployeeWiseNotInTheLocationEmployeePhoto = async (stateId, districtId, fromDate, toDate) => {
  if (!fromDate || !toDate) {
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), "yyyy-MM-dd");
    const formattedToDate = format(new Date(toDate), "yyyy-MM-dd");

    let url =
      `/api/attendance/attendance-distance-violations-details` +
      `?stateId=${stateId}` +
      `&fromDate=${formattedFromDate}` +
      `&toDate=${formattedToDate}`;

    // Only send districtId when it has a value
    if (districtId !== null && districtId !== undefined && districtId !== "") {
      url += `&districtId=${districtId}`;
    }
    //  if(zoneId){
    //   url+=`&zoneId=${zoneId}`
    // }

    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching attendance violation details:",
      error
    );
    throw error;
  }
};



export const gettingAttendaceEmployeeWiseNotInLocationPhoto = async (stateId, districtId, employee, fromDate, toDate) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');

    const response = await api.get(`/api/attendance/employee-attendance-violations?stateId=${stateId}&districtId=${districtId}&employeeUniqueId=${employee}&fromDate=${formattedFromDate}&toDate=${formattedTodate}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}


//https://hrms.4gid.com/api/attendance/remarks/distance/list?loggedInEmployeeUniqueId=338765&fromDate=2026-08-24&toDate=2026-09-01

export const gettingApproveOrRejectAttendanceEmployee = async (employee, fromDate, toDate) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');

    const response = await api.get(`api/attendance/remarks/distance/list?loggedInEmployeeUniqueId=${employee}&fromDate=${formattedFromDate}&toDate=${formattedTodate}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}
export const updateAttendanceStatus = async (payload) => {
  try {
    const response = await api.put('api/attendance/approval-status', payload);
    return response.data;
  } catch (error) {
    console.error("Error updating attendance status:", error);
    throw error;
  }
};



// http://localhost:8080/api/attendance/attendance-remarks-alerts?stateId=3&fromDate=2026-09-01&toDate=2026-09-05&status=ALL
export const stateWiseCountemployeeAttendanceStatusReport = async (stateId, districtId, fromDate, toDate, status, zoneId) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');
    let url = `/api/attendance/attendance-remarks-alerts?stateId=${stateId}&fromDate=${formattedFromDate}&toDate=${formattedTodate}&status=${status}`;
    if (districtId) {
      url += `&districtId=${districtId}`;
    }
    const hasValidZoneId = zoneId && zoneId !== 'null' && zoneId !== 'undefined' && zoneId !== '';
    if (hasValidZoneId && !isPM) {
      url += `&zoneId=${zoneId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}
export const employewiseDetailsFortheSelectedEmployee = async (stateId, districtId, employee, fromDate, toDate, status) => {
  // Add validation for dates
  // http://localhost:8080/api/attendance/employee-attendance-remarks-details?stateId=3&districtId=8&fromDate=2026-09-01&toDate=2026-09-05&status=ALL&employeeUniqueId=861433
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');

    const response = await api.get(`/api/attendance/employee-attendance-remarks-details?stateId=${stateId}&districtId=${districtId}&employeeUniqueId=${employee}&fromDate=${formattedFromDate}&toDate=${formattedTodate}&status=${status}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}


// http://localhost:8080/api/attendance/attendance-district-remarks-summary?stateId=3&fromDate=2026-09-05&toDate=2026-09-05&status=PENDING

export const gettingAttendanceDistrictwiseSummaryforAttendOrNotReport = async (stateId, fromDate, toDate, status, zoneId) => {
  try {

    const formattedFromDate = format(new Date(fromDate), "yyyy-MM-dd");
    const formattedToDate = format(new Date(toDate), "yyyy-MM-dd");

    let url =
      `/api/attendance/attendance-district-remarks-summary` +
      `?stateId=${stateId}` +
      `&fromDate=${formattedFromDate}` +
      `&toDate=${formattedToDate}` + `&status=${status}`;

    // Only send districtId when it has a value
    // if (districtId !== null && districtId !== undefined && districtId !== "") {
    //   url += `&districtId=${districtId}`;
    // }
    const hasValidZoneId = zoneId && zoneId !== 'null' && zoneId !== 'undefined' && zoneId !== '';
    if (hasValidZoneId && !isPM) {
      url += `&zoneId=${zoneId}`;
    }
    const response = await api.get(url);


    return response.data;
  } catch (error) {
    console.error(
      "Error fetching district violations summary:",
      error
    );
    throw error;
  }
};

// http://localhost:8080/api/attendance/attendance-remarks-details?stateId=3&districtId=8&fromDate=2026-09-05&toDate=2026-09-05&status=ALL
export const gettingAttendaceEmployeeWiseNotInTheLocationEmployeePhotoReport = async (stateId, districtId, fromDate, toDate, status) => {
  if (!fromDate || !toDate) {
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), "yyyy-MM-dd");
    const formattedToDate = format(new Date(toDate), "yyyy-MM-dd");

    let url =
      `/api/attendance/attendance-remarks-details` +
      `?stateId=${stateId}` +
      `&fromDate=${formattedFromDate}` +
      `&toDate=${formattedToDate}` + `&status=${status}`;

    // Only send districtId when it has a value
    if (districtId !== null && districtId !== undefined && districtId !== "") {
      url += `&districtId=${districtId}`;
    }
    //  if(zoneId){
    //   url+=`&zoneId=${zoneId}`
    // }

    const response = await api.get(url);

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching attendance violation details:",
      error
    );
    throw error;
  }
};

// app and field attendance compare

// http://localhost:8080/api/analytics/attendance/designation-summary?stateId=3&districtId=1&year=2026&month=8
export const getAppAndFieldAttendanceCompare = async (stateId, districtId, year, month,designation) => {
  let url = `api/analytics/attendance/designation-summary?stateId=${stateId}&year=${year}&month=${month}`;

  if (districtId !== null && districtId !== undefined && districtId !== "") {
    url += `&districtId=${districtId}`;
  }
  if (designation !== null && designation !== undefined && designation !== "") {
    url += `&designations=${designation}`;
  }

  const response = await api.get(url);
  return response.data;
};

// drill down api  attendance compare
// http://192.168.1.121:8080/api/analytics/attendance/district-designation-summary?stateId=3&year=2026&month=6&designation=DEO
export const getAppAndFieldAttendanceCompareDrilldown = async (stateId, districtId, year, month,designation) => {
  let url = `api/analytics/attendance/district-designation-summary?stateId=${stateId}&year=${year}&month=${month}`;

  if (districtId !== null && districtId !== undefined && districtId !== "") {
    url += `&districtId=${districtId}`;
  }
  if (designation !== null && designation !== undefined && designation !== "") {
    url += `&designation=${designation}`;
  }

  const response = await api.get(url);
  return response.data;
};

// employee Drill down api attendace
// http://192.168.1.121:8080/api/analytics/attendance/employee-summary?districtId=1&year=2026&month=6&designation=DEO
export const getEmployeeSummaryDrilldown = async (districtId, year, month, designation) => {
    let url = `/api/analytics/attendance/employee-summary?districtId=${districtId}&year=${year}&month=${month}`;

  if (designation !== null && designation !== undefined && designation !== "") {
    url += `&designation=${designation}`;
  }

  const response = await api.get(url);
  return response.data;
};

// employee full details
// http://localhost:8080/api/analytics/attendance/employee-details?year=2026&month=8&employeeUniqueId=305358
export const getEmployeeSummaryDrilldownFullDetails = async ( year, month, employeeUniqueId) => {
    let url = `/api/analytics/attendance/employee-details?&year=${year}&month=${month}&employeeUniqueId=${employeeUniqueId}`;
  const response = await api.get(url);
  return response.data;
};


